<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <edit-plan-form
          v-bind:subscription="subscription"
          header-color="primary"
        ></edit-plan-form>
        <!-- <usage-chart
          ref="browser-share"
          :title="'System Usage'"
          :billingDateUTC="billingDateUTC"
          :billingUnit="billingUnit"
          :creationDateUTC="creationDate"
          :noDataMsg="'It looks like you have had no active web connections for the selected Application.'"
        ></usage-chart> -->
      </div>
    </div>
  </div>
</template>
<script>
import { EditPlanForm } from "@/pages";
import { get } from "vuex-pathify";
import { setSubscriptionStatus } from "../../utils/auth0";
import { updateSubscription } from "../../utils/appcues";
// import UsageChart from "./UsageChart.vue"; // LSA-62
export default {
  components: {
    EditPlanForm,
    // UsageChart,
  },
  computed: {
    subscription: get("subscription/subscription"),
    submitErrorsOccurred: get("subscription/errorsOccurred"),
  },
  data() {
    return {
      billingDateUTC: null,
      billingUnit: null,
      creationDate: null,
    };
  },
  created() {
    this.$store.dispatch("applications/loadEntities").then(
      this.$store
        .dispatch("subscription/loadSubscription", localStorage.subscriptionId)
        .then((result) => {
          setSubscriptionStatus(result.status);
          this.billingDateUTC = result.nextBillingOn;
          this.billingUnit = result.billingUnit;
          this.creationDate = result.createdOn;
          var query = new URLSearchParams(window.location.search);
          if (query.has("update")) {
            updateSubscription(result);
            window.location.replace("#/subscription");
            window.history.pushState({}, document.title, "/#/subscription");
          }
        })
    );
  },
};
</script>
<style type="scss">
.ls-status-block {
  padding-bottom: 10px;
}
.ls-support-status-block {
  padding-bottom: 30px;
}
.ls-label {
  margin-right: 10px;
}
.ls-float-right {
  float: right;
}
</style>
